import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getDataOpenended: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide-option/list?page={page}&pageSize={pageSize}&slideId={slideId}`,
  },
  getSlideOptions: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide-option/list/`,
  },
  patchSlideOptionById: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/slide-option/{slideOptionId}`,
  },
  createSlideOption: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide-option/create/`,
  },
  createSpinnerWheelOptions: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide-option/spinner-wheel/options/`,
  },
  updateSlideOption: {
    method: 'PUT',
    url: `${configs.baseUrl}/api/slide-option/update/{slideOptionId}`,
  },
  deleteSlideOption: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/slide-option/{slideOptionId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getDataOpenended = (page, pageSize, slideId) => {
  return resource.getDataOpenended({ page, pageSize, slideId })
}

const getSlideOptions = async (query) => {
  const res = await resource.getSlideOptions(query)
  return res.body
}

const patchSlideOptionById = async (slideOptionId, payload) => {
  const res = await resource.patchSlideOptionById({ slideOptionId }, payload)
  return res.body.slideOption
}

const createSlideOption = async (payload) => {
  const res = await resource.createSlideOption(payload)
  return res.body
}

const createSpinnerWheelOptions = async (payload) => {
  const res = await resource.createSpinnerWheelOptions(payload)
  return res.body
}

const updateSlideOption = (slideOptionId, payload) => {
  return resource.updateSlideOption({ slideOptionId }, payload)
}

const deleteSlideOption = async (slideOptionId, payload) => {
  const res = await resource.deleteSlideOption({ slideOptionId }, payload)
  return res.body.slide
}

export default {
  initResource,
  getDataOpenended,
  patchSlideOptionById,
  createSlideOption,
  updateSlideOption,
  deleteSlideOption,
  getSlideOptions,
  createSpinnerWheelOptions,
}
